module.exports = __webpack_public_path__ + "static/img/a2.9806a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a2.png
// module id = 26
// module chunks = 1